import request from "@/utils/requestJSON";

export function getAboutUsCommon() {
  return request({
    url: "/storage/AboutUs/AboutUSCommon.json",
    method: "get",
  });
}

export function getCompanyProfile() {
  return request({
    url: "/storage/AboutUs/CompanyProfile.json",
    method: "get",
  });
}

export function getCompanyManage() {
  return request({
    url: "/storage/AboutUs/CompanyManage.json",
    method: "get",
  });
}

export function getCSR() {
  return request({
    url: "/storage/AboutUs/CSR.json",
    method: "get",
  });
}

export function getPublicInfomation() {
  return request({
    url: "/storage/AboutUs/PublicInfomation.json",
    method: "get",
  });
}

export function getNews() {
  return request({
    url: "/storage/AboutUs/News.json",
    method: "get",
  });
}

export function getAnnouncement() {
  return request({
    url: "/storage/AboutUs/Announcement.json",
    method: "get",
  });
}

export function getPublicWelfare() {
  return request({
    url: "/storage/AboutUs/PublicWelfare.json",
    method: "get",
  });
}

export function getEmployeeCare() {
  return request({
    url: "/storage/AboutUs/EmployeeCare.json",
    method: "get",
  });
}

export function getEmployeeCareNews() {
  return request({
    url: "/storage/AboutUs/EmployeeCareNews.json",
    method: "get",
  });
}

export function getFinancialFriendly() {
  return request({
    url: "/storage/AboutUs/FinancialFriendly.json",
    method: "get",
  });
}

export function getSociety() {
  return request({
    url: "/storage/AboutUs/Society.json",
    method: "get",
  });
}

export function getEnvironment() {
  return request({
    url: "/storage/AboutUs/Environment.json",
    method: "get",
  });
}

export function getStakeholder() {
  return request({
    url: "/storage/AboutUs/Stakeholder.json",
    method: "get",
  });
}

export function getCompanyHonor() {
  return request({
    url: "/storage/AboutUs/CompanyHonor.json",
    method: "get",
  });
}

export function getShareholderServices() {
  return request({
    url: "/storage/AboutUs/ShareholderServices.json",
    method: "get",
  });
}

export function getShareholderMeeting() {
  return request({
    url: "/storage/AboutUs/ShareholderMeeting.json",
    method: "get",
  });
}

export function getImportantNews() {
  return request({
    url: "/storage/AboutUs/ImportantNews.json",
    method: "get",
  });
}
